<template>
  <!-- 底部导航 -->
  <div class="footer">
    <div class="w980 pc_block">
      <div class="ewm fl">
        <div>
          <img
              src="../assets/img/new_whitelogo.png"
              style="width: 115px;"
              alt=""
          />
        </div>
        <div style="margin: 10px 0;">
          <img
              src="https://omo-oss-image.thefastimg.com/portal-saas/new2022051809265841846/cms/image/9e2bf992-ef60-4949-968e-9d160adf52fc.jpg_186xaf.jpg"
              width="120" height="120"
          />
        </div>
        <p>安耐杰微信公众平台</p>
      </div>
      <div class="footer-main fr">
        <div class="menu">
          <li><a class="tit" @click="goPages('/index')">首页</a></li>
          <li><a class="tit" @click="goPages('/plat/index')">安耐杰云平台</a></li>
          <li><a class="tit" @click="goPages('/scheme/index')">解决方案</a></li>
          <li><a class="tit" @click="goPages('/product/index')">产品中心</a></li>
          <li><a class="tit" @click="goPages('/example/index')">项目案例</a></li>
          <li><a class="tit" @click="goPages('/news/index')">新闻中心</a></li>
          <li><a class="tit" @click="goPages('/company/index')">关于我们</a></li>
          <li><a class="tit last" @click="goPages('/company/contact')">联系我们</a></li>
        </div>
        <p>
          <span>地址：浙江省台州市椒江区海门街道慧谷北路61号</span>
          <span style="margin-left: 20px">联系电话：400 1578 100，0576-8859 6888</span>
        </p>
        <p>
          <span>传真：0576-8899 8666</span>
          <span style="margin-left: 20px">邮箱：anjpower@163.com</span>
        </p>
        <p>Copyright © 2023 台州安耐杰电力设备有限公司 All Rights Reserved</p>
        <p class="fl">技术支持：台州安耐杰电力设备有限公司</p>
        <p class="sys-record" style="width: 100%; overflow: hidden; display: block;"><a href="https://beian.miit.gov.cn/" target="_blank">备案号：浙ICP备11030359号</a> </p>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="w980 mimi_block">
      <div class="footer-main fr">
        <p>地址：浙江省台州市椒江区海门街道慧谷北路61号</p>
        <p>联系电话：400 1578 100，0576-8859 6888</p>
        <p>传真：0576-8899 8666</p>
        <p>邮箱：anjpower@163.com</p>
        <p>Copyright ©2023 台州安耐杰电力设备有限公司</p>
        <p>技术支持：台州安耐杰电力设备有限公司</p>
        <p class="sys-record"><a href="https://beian.miit.gov.cn/" target="_blank">备案号：浙ICP备11030359号</a> </p>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
      <div class="ewm fl">
        <div style="margin: 10px 0;">
          <img
              src="https://omo-oss-image.thefastimg.com/portal-saas/new2022051809265841846/cms/image/9e2bf992-ef60-4949-968e-9d160adf52fc.jpg_186xaf.jpg"
              width="120" height="120"
          />
        </div>
        <p>安耐杰微信公众平台</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
  methods: {
    goPages(val) {
      let self = this;
      this.$router.push(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  overflow: hidden;
  background: #091b27;
  .sys-record{
    a:hover{
      color: #4288ff!important;
    }
  }
  .mimi_block{
    display: none;
  }
  a {
    text-decoration: none;
    color: #cbd2de;
  }
  .fr {
    float: right;
    display: inline;
  }
  .footer-main {
    //width: 915px;
    width: 1050px;
    line-height: 35px;
    color: #cbd2de;
    letter-spacing: 1px;
    text-transform: uppercase;

    .menu {
      height: 50px;
      border-bottom: 1px solid #fff;
      margin-bottom: 19px;
      display: flex;
      justify-content: space-around;
      p {
        color: #cbd2de;
      }
      a {
        cursor: pointer;
        transition: color 500ms ease-in 0ms;
        display: inline-block;
        text-decoration: none;
        font-size: 14px;
        line-height: 50px;
        color: #e7e7e7;
      }
      li {

        list-style: none;
      }
    }
  }
  .w980 {
    position: relative;
    width: 1350px;
    overflow: hidden;
    margin: 0 auto;
    padding: 25px 0;
    .ewm {
      width: 250px;
      line-height: 24px;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
  }
  @media screen and(max-width:768px){
    .pc_block{
      display: none!important;
    }
    .mimi_block{
      display:block!important ;
      width: calc(100% - 20px) !important;
      padding: 10px;
      font-size: 14px!important;
    }
    .fl{
      float: unset!important;
      display: none!important;
    }
    .footer-main{
      width: 100%!important;
      line-height: 25px!important;
    }
  }
}
</style>
